export default [
  {
    key: 'firstName',
    label: 'field.firstName',
    rules: 'required|max:50',
    type: 'text',
  },
  {
    key: 'lastName',
    label: 'field.lastName',
    rules: 'required|max:50',
    type: 'text',
  },
  {
    key: 'phone',
    label: 'field.phoneNumber',
    rules: 'required|min:9|max:10',
    type: 'tel',
    cols: 12,
  },
  {
    key: 'password',
    name: 'new-password',
    placeholder: 'placeholder.password',
    label: 'field.password',
    rules: 'required|min:6',
    type: 'password',
    cols: 12,
  },
  {
    key: 'retypePassword',
    label: 'field.retypePassword',
    placeholder: 'placeholder.password',
    rules: 'required|confirmed:password',
    type: 'password',
    cols: 12,
  },
]
